import { UtilityServices } from "../../../core/services/UtilityServices";
import { AlertModal } from "../../components/Modals/AlertModal/AlertModal";
import React, { useState } from "react";
import { Button } from "rsuite";
import { statusArr } from "../../../core/config/AppConstants";
import { useTranslation } from "react-i18next";

const ReportBulkAction = ({
  checkedKeys,
  setCheckedKeys,
  onExportReport,
  ...props
}: {
  checkedKeys: any;
  setCheckedKeys: Function;
  onExportReport?: any;
}) => {
  const { t } = useTranslation();
  const [openBulkActionNoSelectionModal, setOpenBulkActionNoSelectionModal] =
    useState(false);
  const [openExportReportModal, setOpenExportReportModal] = useState(false);

  return (
    <div className="report-action col-md-8">
      <div className="report-action-toolbar">
        <div className="report-action-title">Bulk Actions</div>
        <div className="report-action-buttons">
          {UtilityServices.hasPermission("export-report") && (
            <Button
              className="report-export-btn"
              appearance="ghost"
              onClick={() => setOpenExportReportModal(true)}
            >
              {t("EXPORT")}
            </Button>
          )}
        </div>
      </div>
      <AlertModal
        open={openBulkActionNoSelectionModal}
        handleClose={(e: any) => {
          if (e) {
            setOpenBulkActionNoSelectionModal(false);
          }
        }}
        displayText={t("PLEASE_SELECT_RECORD_TO_ACTION")}
        modalTitle={t("PLEASE_SELECT")}
        cancelButton={false}
      />
      <AlertModal
        open={openExportReportModal}
        handleClose={(e: any) => {
          if (e == true) {
            onExportReport();
            setOpenExportReportModal(false);
          } else {
            setOpenExportReportModal(false);
          }
        }}
        displayText={t("CONFIRM_ACTION_ALL", {
          action: t("EXPORT").toLowerCase(),
          entity: t("REPORT").toLowerCase(),
        })}
        modalTitle={t("CONFIRM_ACTION_TITLE", {
          action: t("EXPORT").toLowerCase(),
        })}
      />
    </div>
  );
};

export default ReportBulkAction;
